import {
  numberOfAccessPoints,
  optionBusinessWifi
} from '../businessWifi/businessWifiFieldNames';
import { addProductVulcan } from '../customerInformation/customerInformationFieldNames';
import {
  offers,
  optionFibreInternet15G
} from '../fibeInternet/fibreInternetFieldNames';
import {
  mobilityMonthlyCharge,
  mobilityOneTimeCharge,
  optionMobility
} from '../mobility/mobilityFieldNames';
import {
  optionSecureBusiness,
  secureBusinessOffersVulcan,
  secureBusinessPlan
} from '../secureBusiness/secureBusinessFieldNames';

import {
  keyMonitorVulcan,
  keyProtectVulcan,
  keyControlVulcan,
  keyControlIncludedEquipmentVulcan,
  keyProtectIncludedEquipmentVulcan,
  keyMonitorIncludedEquipmentVulcan,
  keyControlIncludedEquipmentCameraSelectionVulcan,
  keyMonitorAdditionalEquipmentVulcan,
  keyProtectAdditionalEquipmentVulcan,
  keyControlAdditionalEquipmentVulcan,
  keyProtectIncludedEquipmentCameraSelectionVulcan
} from '../../../utils/constant';

import { getFieldValue } from '../../utils';

export const GET_FIELD_VALUE = 'GET_FIELD_VALUE';

const includedEquipmentValuesMap = {
  [keyMonitorVulcan]: [keyMonitorIncludedEquipmentVulcan],
  [keyProtectVulcan]: [
    keyProtectIncludedEquipmentVulcan,
    keyProtectIncludedEquipmentCameraSelectionVulcan
  ],
  [keyControlVulcan]: [
    keyControlIncludedEquipmentVulcan,
    keyControlIncludedEquipmentCameraSelectionVulcan
  ]
};

const additionalEquipmentValuesMap = {
  [keyMonitorVulcan]: [keyMonitorAdditionalEquipmentVulcan],
  [keyProtectVulcan]: [keyProtectAdditionalEquipmentVulcan],
  [keyControlVulcan]: [keyControlAdditionalEquipmentVulcan]
};

const summaryConfig = [
  {
    sectionTitle: 'Fibre Internet',
    shouldShowSection: formFields => {
      return getFieldValue(addProductVulcan, formFields).includes(
        optionFibreInternet15G
      );
    },
    rows: [
      {
        label: 'Speed',
        description: '1.5G',
        checkForKey: addProductVulcan,
        checkForOption: 'Fibre Internet 1.5G'
      },
      {
        label: 'Offer(s)',
        listSelectedOptionsForKey: offers
      }
    ]
  },
  {
    sectionTitle: 'Business Wifi',
    shouldShowSection: formFields => {
      return getFieldValue(addProductVulcan, formFields).includes(
        optionBusinessWifi
      );
    },
    rows: [
      {
        label: 'Device(s)',
        description: 'MR28',
        checkForKey: addProductVulcan,
        checkForOption: 'Business Wifi'
      },
      {
        label: 'Additional Access Points',
        checkForKey: numberOfAccessPoints,
        transformer: value => {
          const qty = +(value.qty || 0);
          const monthlyChargesPerUnit = value.monthlyCharges / qty;
          return {
            ...value,
            qty: qty - 1,
            monthlyCharges: monthlyChargesPerUnit * (qty - 1)
          };
        }
      }
    ]
  },
  {
    sectionTitle: 'Secure Business',
    shouldShowSection: formFields => {
      return getFieldValue(addProductVulcan, formFields).includes(
        optionSecureBusiness
      );
    },
    rows: [
      {
        label: 'Plan',
        description: GET_FIELD_VALUE,
        checkForKey: secureBusinessPlan
      },
      {
        label: 'Included',
        listSelectedValuesForEquipment: {
          basedOnKey: secureBusinessPlan,
          map: includedEquipmentValuesMap
        }
      },
      {
        label: 'Additional Equipment (One Time Payment)',
        listSelectedValuesForEquipment: {
          basedOnKey: secureBusinessPlan,
          map: additionalEquipmentValuesMap,
          filterKeysBySubstringNegative: ['easyThreeYear', 'easyFiveYear']
        }
      },
      {
        label: 'Additional Equipment (3 Year Easy Payment)',
        listSelectedValuesForEquipment: {
          basedOnKey: secureBusinessPlan,
          map: additionalEquipmentValuesMap,
          filterKeysBySubstring: 'easyThreeYear'
        }
      },
      {
        label: 'Additional Equipment (5 Year Easy Payment)',
        listSelectedValuesForEquipment: {
          basedOnKey: secureBusinessPlan,
          map: additionalEquipmentValuesMap,
          filterKeysBySubstring: 'easyFiveYear'
        }
      },
      {
        label: 'Offer(s)',
        listSelectedOptionsForKey: secureBusinessOffersVulcan
      }
    ]
  },
  {
    sectionTitle: 'Mobility',
    shouldShowSection: formFields => {
      return getFieldValue(addProductVulcan, formFields).includes(
        optionMobility
      );
    },
    rows: [
      { label: 'Mobility Monthly Charge', checkForKey: mobilityMonthlyCharge },
      { label: 'Mobility One Time Charge', checkForKey: mobilityOneTimeCharge }
    ]
  }
];

export default summaryConfig;
